// Module-level helper functions for fee structure
import { formatCurrencyDisplay } from "../localization/localization.helpers";

/** Format amount with currency symbol (e.g., "₹ INR 1,000") for fee displays */
export const formatAmountWithCurrency = (amount: number, currencyCode: string) =>
  `${formatCurrencyDisplay(currencyCode)} ${amount.toLocaleString()}`;
